import { STRINGS } from "../constants/strings";

interface Props {
  companyName: string;
  companyLogoUrl: string | null;
  title?: string;
  subtitle?: string;
}

export function BrandHeader({
  companyName,
  companyLogoUrl,
  title = STRINGS.title,
  subtitle = STRINGS.subtitle,
}: Props) {
  const initial = companyName.trim().charAt(0).toUpperCase() || "?";

  return (
    <header class="tl-hero">
      <div class="tl-hero__avatar">
        {companyLogoUrl ? (
          <img src={companyLogoUrl} alt="" />
        ) : (
          <span>{initial}</span>
        )}
      </div>
      <div class="tl-hero__company">{companyName}</div>
      <h1 class="tl-hero__title">{title}</h1>
      <p class="tl-hero__subtitle">{subtitle}</p>
    </header>
  );
}
